<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <v-select
          v-model="selectedMake"
          :items="makes"
          label="Make *"
          outlined
          :rules="[$validation.required]"
          required
          item-text="make"
          :item-value="itemValue"
          hide-details
          @change="handleMake"
        />
      </v-col>

      <v-col
        cols="12"
        md="3"
      >
        <v-select
          v-model="selectedModel"
          :items="models"
          label="Model *"
          outlined
          :rules="[$validation.required]"
          required
          item-text="title"
          :item-value="itemValue"
          hide-details
          @change="handleModel"
        />
      </v-col>

      <v-col
        cols="12"
        md="3"
      >
        <v-select
          v-model="selectedWarranty"
          :items="warranties"
          label="Warranty *"
          outlined
          :rules="[$validation.required]"
          required
          item-text="warranty"
          :item-value="itemValue"
          hide-details
          @change="handleWarranty"
        >
          <template
            slot="item"
            scope="data"
          >
            <v-list-item-content>
              <v-list-item-title v-html="data.item.warranty" />
              <v-list-item-subtitle v-html="data.item.type" />
            </v-list-item-content>
          </template>
        </v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <v-text-field
          v-model="travelDistance"
          placeholder="Travel Distance"
          flat
          outlined
          hide-details
          type="number"
          @keyup="handleDistance"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <v-switch
          v-model="requireInstallation"
          label="Require installation"
          @change="handleInstallation"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <v-switch
          v-model="ccpayment"
          label="Credit Card Payment"
          @change="handlePayment"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="4"
        :key="`price-${price.id}-${i}`"
        v-for="(price, i) in priceList"
      >
        <v-card>
          <v-card-title>{{price.make}}</v-card-title>
          <v-card-subtitle>{{price.warranty.replace('unlimited mileage warranty', '')}} ({{price.warrantyType}})</v-card-subtitle>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th></th>
                  <th>Customer Price</th>
                  <th>Shop Price</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in billItems"
                  :key="item.name"
                >
                  <td>{{ item.name }}</td>
                  <td>{{ price[item.value] }}</td>
                  <td>{{ price[item.business] }}</td>
                </tr>
                <tr>
                  <th>Total</th>
                  <th>{{ price.total }}</th>
                  <th>{{ price.businessTotal }}</th>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ExternalService from "../../services/ExternalService";
import { getOfficeTaxRate } from "../../utils/officeLocation";

function distanceCost(distance) {
  let cost = 0;
  if(distance > 100) {
    cost = parseInt(distance)
  } else if (distance > 75) {
    cost = 100
  } else if (distance > 50) {
    cost = 75
  } else if (distance > 25) {
    cost = 50
  } else if (distance > 0) {
    cost = 25
  }
  return cost;
}

function getInstallationCost(model) {
  let cost = 0;
  if(model && model.installation) {
    cost = parseInt(model.installation.replace(/^\D+/g, '')) || 0
  }
  // console.log('getInstallationCost', model)
  return cost;
}

function getTax(warranty, model, taxRate, installationCost = 0, location) {
  let customerCost = 0
  let customerTax = 0;
  let businessCost = 0
  let businessTax = 0;
  
  if(warranty && warranty.customerCost) {
    customerCost = parseFloat(warranty.customerCost.replace(/[,$]/g, ''));
  }  
  if(warranty && warranty.businessCost) {
    businessCost = parseFloat(warranty.businessCost.replace(/[,$]/g, ''));
  }
  if(!model.installation.includes('tax included')) {
    customerTax = parseFloat((customerCost * taxRate).toFixed(2));
    if (location === 'WA') {
      customerTax += parseFloat((installationCost * taxRate).toFixed(2));
    }
  }
  if(!model.installation.includes('tax included')) {
    businessTax = parseFloat((businessCost * taxRate).toFixed(2));
    if (location === 'WA') {
      businessTax += parseFloat((taxRate).toFixed(2));
    }
  }
  return { customerCost, customerTax, businessCost, businessTax };
}

export default {
  name: "PriceCalculatorPage",
  data() {
    return {
      options: {},
      selectedMake: '',
      selectedModel: '',
      selectedWarranty: '',
      requireInstallation: true,
      ccpayment: false,
      total: 0,
      travelDistance: null,
      makes: [],
      models: [],
      warranties: [],
      taxRate: "",
      priceList: [],
      billItems: [
        {
          name: 'Battery Cost',
          value: 'batteryCost',
          business: "businessCost" 
        },
        {
          name: 'Sales Tax',
          value: 'tax',
          business  : "businessTax"
        },
        // {
        //   name: 'To',
        //   value: 'total',
        // },
        {
          name: 'Installation Cost',
          value: 'installationCost',
          business: 'businessInstallationCost',
        },
        {
          name: 'Mobile Service',
          value: 'distanceCost',
          business: 'distanceCost',
        },
        {
          name: 'Credit Card Charges',
          value: 'cccharges',
          business: 'ccbusiness',
          interpolate: (item) => item.cccharges
        },
      ]
    }
  },
  async mounted() {
    const location = this.selectedLocation;
    this.taxRate = await getOfficeTaxRate(location);
    this.loadBatteries();
  },
  methods: {
    async loadBatteries() {
      const batteries = await ExternalService.getBatteries();
      this.makes = batteries.data;
    },
    itemValue(item) {
      return item;
    },
    handleMake(item) {
      this.models = item.models || [];
      this.selectedModel = '';
      this.selectedWarranty = '';
    },
    handleModel(item) {
      this.warranties = item.batteries || [];
      this.selectedWarranty = '';
      this.calculateTotal();
      this.updatePricing();
    },
    handleWarranty() {
      this.calculateTotal();
      this.updatePricing();
    },
    handleDistance() {
      this.calculateTotal();
      this.updatePricing();
    },
    handleInstallation() {
      this.calculateTotal();
      this.updatePricing();
    },
    handlePayment() {
      this.calculateTotal();
      this.updatePricing();
    },
    calculateTotal() {
      let total = 0;
      const dcost = distanceCost(this.travelDistance);
      const installationCost = this.requireInstallation ? getInstallationCost(this.selectedModel) : 0;
      const taxRate = this.taxRate / 100;
      const { customerCost, customerTax, businessCost, businessTax } = getTax(this.selectedWarranty, this.selectedModel, taxRate, installationCost, this.selectedLocation);
      total = dcost + installationCost + customerCost + customerTax;


      if(this.ccpayment) {
        const cccharges = parseFloat((total * .03).toFixed(2))
        total += cccharges;
      }
      this.total = total;
      this.businessTotal = dcost + businessCost + businessTax
    },
    updatePricing() {
      const priceList = [];
      if(this.selectedWarranty) {
        priceList.push(this.getWarrantyPrice(this.selectedWarranty))
      } else {
        this.warranties.forEach(item => {
          priceList.push(this.getWarrantyPrice(item))
        });
      }
      this.priceList = priceList;
    },
    getWarrantyPrice(item) {
      const dcost = distanceCost(this.travelDistance);
      const installationCost = this.requireInstallation ? getInstallationCost(this.selectedModel) : 0;

      let total = 0, cccharges = 0, ccbusiness = 0;
      const taxRate = this.taxRate / 100;
      const { customerCost, customerTax, businessCost, businessTax } = getTax(item, this.selectedModel, taxRate, installationCost, this.selectedLocation);
      // if(item && item.cost) {
      //   batteryCost = parseFloat(item.cost.replace(/[,$]/g, ''));
      //   const taxRate = this.taxRate / 100;
      //   tax = parseFloat((batteryCost * taxRate).toFixed(2));
      // }
      total = dcost + installationCost + customerCost + customerTax;
      let businessTotal = dcost + businessCost + businessTax
      if(this.ccpayment) {
        cccharges = parseFloat((total * .03).toFixed(2))
      }
      if(this.ccpayment) {
        ccbusiness = parseFloat((businessTotal * .03).toFixed(2))
      }
      total += cccharges;
      businessTotal += ccbusiness;
      return {
        id: new Date().getTime(),
        make: this.selectedModel.title,
        warranty: item.warranty,
        warrantyType: item.type,
        batteryCost: customerCost,
        tax: (customerTax).toFixed(2),
        cccharges,
        total: (total).toFixed(2),
        installationCost,
        businessInstallationCost: 0,
        distanceCost: dcost,
        businessCost,
        businessTax: (businessTax).toFixed(2),
        businessTotal: (businessTotal).toFixed(2),
        ccbusiness,
      }
    }
  }
}
</script>